import { fetchUser, setUserSession } from './user';
import { setAuthTokenFromCookie } from '../utils/authToken';
import trackEvent from './events';
import { setAnalyticsUser } from '../utils/mixpanel';
import { beginAuthAttempt, finishAuthAttempt, authReason, hasAuthenticatedUser } from '../utils/authAnalytics';

const setInitialized = () => ({
  type: 'SET_INITIALIZED',
});

const setBackgroundClass = (image) => ({
  type: 'SET_BACKGROUND_IMAGE',
  image: `url(${image})`,
});

const clearBackgroundClass = () => ({
  type: 'SET_BACKGROUND_IMAGE',
  image: 'none',
});

const runWhenBrowserIsIdle = (callback) => {
  if (typeof window === 'undefined') return;

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 3000 });
    return;
  }

  window.setTimeout(callback, 1);
};

const trackAppOpen = () => {
  runWhenBrowserIsIdle(() => {
    import('ua-parser-js').then((module) => {
      const uaParser = module.default || module;
      const ua = uaParser(navigator.userAgent);

      trackEvent({
        event_type: 'App Open',
        open_type: 'Normal',
        os_type: ua?.os?.name,
        os_version: ua?.os?.version,
        device_type: ua?.device?.model,
        preferred_language: window.navigator.userLanguage || window.navigator.language,
        timestamp: Math.ceil(new Date().valueOf() / 1000),
      });
    });
  });
};

const initialize = () => {
  const authToken = setAuthTokenFromCookie();

  return async (dispatch) => {
    if (!authToken) {
      setAnalyticsUser(null);
      dispatch(setInitialized());
      trackAppOpen();
      return;
    }

    const attempt = beginAuthAttempt('session_restore', 'unknown');
    try {
      const response = await fetchUser();
      await dispatch(setUserSession(response.data));
      finishAuthAttempt(attempt, hasAuthenticatedUser(response.data) ? 'success' : 'guest');
    } catch (error) {
      if ([401, 404, 412].includes(error?.status || error?.response?.status)) {
        setAnalyticsUser(null);
      }
      finishAuthAttempt(attempt, 'failure', authReason(error));
    }

    dispatch(setInitialized());
    trackAppOpen();
  };
};

export { initialize, setBackgroundClass, clearBackgroundClass };
